<div class="dialog-content">
  <!-- Title outside container -->
  <div class="dialog-title">
    <mat-icon class="title-icon">local_shipping</mat-icon>
    <h1>{{ "app.batchShipments.title" | translate }}</h1>
  </div>

  <!-- The bordered report rectangle -->
  <div class="report-container">
    <table class="report-table">
      <thead>
        <tr>
          <th>{{ "app.batchShipments.orderNumber" | translate }}</th>
          <th style="white-space: nowrap">{{ "app.batchShipments.carrier" | translate }}</th>
          <th class="service-column">{{ "app.batchShipments.serviceDescription" | translate }}</th>
          <th>{{ "app.batchShipments.trackingNumber" | translate }}</th>
          <th>{{ "app.batchShipments.shipmentDate" | translate }}</th>
          <th>{{ "app.batchShipments.deliveryDate" | translate }}</th>
          <th class="issue-column">{{ "app.batchShipments.issue" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        @for (shipment of shipments; track shipment) {
          <tr [ngClass]="{ 'issue-row': shipment.Issue }">
            <td>
              @if (shipment.StatusType === 8 && shipment.Issue) {
                <button mat-stroked-button color="primary" class="order-btn" (click)="GoToOrder(shipment.OrderNumber)">
                  <mat-icon class="icon material-icons">rate_review</mat-icon>
                  {{ shipment.OrderNumber }}
                </button>
              }
              @if (!(shipment.StatusType === 8 && shipment.Issue)) {
                <span>
                  {{ shipment.OrderNumber }}
                </span>
              }
            </td>
            <td>{{ shipment.Carrier }}</td>
            <td>{{ shipment.ServiceDescription }}</td>
            <td style="white-space: nowrap">{{ shipment.TrackingNumber }}</td>
            <td>{{ shipment.ShipmentDate | date: "yyyy-MM-dd" }}</td>
            <td>{{ shipment.DeliveryDate | date: "yyyy-MM-dd" }}</td>
            <td>
              @if (shipment.Issue) {
                <button color="primary" class="see-issue-btn" (click)="showIssue(shipment)">
                  <mat-icon>visibility</mat-icon>
                  <!-- {{ 'app.batchShipments.seeIssue' | translate }} -->
                </button>
              }
            </td>
          </tr>
        }
        @if (!shipments.length) {
          <tr>
            <td colspan="5" class="no-data">
              {{ "app.batchShipments.noData" | translate }}
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <!-- Footer -->
  <div class="dialog-footer">
    <button mat-raised-button color="warn" class="close-btn" (click)="close()">
      <mat-icon>cancel</mat-icon>
      {{ "app.batchShipments.close" | translate }}
    </button>
  </div>
</div>
